/*
 * Copyright (c) 2022-2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import ConsumeType from '@/model/dataLayer/api/buffet/ConsumeType'
import WeekDays from '@/model/dataLayer/api/common/WeekDays'
import IKUtils from 'innerken-js-utils'
import { showSuccessMessage } from '@/model/utils/utils'
import i18n from '@/i18n'

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    displayName: 'id',
    tableConfig: {
      align: 'start'
    },
    header: false,
    formConfig: {
      requiredNew: false
    },
    form: false
  },

  fromTime: {
    type: IKDataEntity.Types.Time
    // displayName: 'Zeit ab',
  },
  toTime: {
    type: IKDataEntity.Types.Time
    // displayName: 'end_time',
  },

  consumeTypeId: {
    // displayName: 'name',
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: ConsumeType.getList,
        itemText: 'name'
      }
    },
    form: false,
    header: false
  },

  dayOfWeek: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: WeekDays.getList(),
        itemText: 'name',
        multiple: true
      }
    }
  }
}

const config = {

  load: async function (filter) {
    return ((await hillo.get('ConsumeType.php?op=showConsumeTypeTimeSpanByConsumeType',
      ...filter
    ))
      .content)
  },
  add: async function (item) {
    const tempItem = item
    for (const dayOfWeek of item.dayOfWeek) {
      tempItem.dayOfWeek = dayOfWeek
      hillo.post('ConsumeType.php?op=addConsumeTypeTimeSpan', {
        ...tempItem
      }, {
        showLoading: false
      })
    }
  },
  remove: function (id) {
    return hillo.post('ConsumeType.php?op=deleteConsumeTypeTimeSpan', { id })
  },
  edit: function (item) {
    return hillo.postWithUploadFile('ConsumeType.php?op=editConsumeTypeTimeSpan', item, {
      showLoading: true
    })
  },
  resetTimeSpan: async function (list) {
    IKUtils.showLoading(true)
    for (const item of list) {
      item.fromTime = '00:00:00'
      item.toTime = '23:59:59'
      hillo.postWithUploadFile('ConsumeType.php?op=editConsumeTypeTimeSpan', item, {
        showLoading: false
      })
    }
    showSuccessMessage(i18n.t('edit_success'))
  }

}

export default IKDataEntity.ModelFactory(entity, config)
